import React from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Heading,
  Text,
  Progress,
  Badge,
  Link,
  HStack,
  Icon,
  Tooltip
} from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { MdTouchApp } from 'react-icons/md';

const TopLinks = ({ links }) => {
  const maxClicks = links.length > 0 ? Math.max(...links.map(l => l.totalClicks)) : 0;

  const formatUrl = (url) => {
    try {
      const urlObj = new URL(url);
      // Remove protocol and www
      let displayUrl = urlObj.hostname + urlObj.pathname;
      displayUrl = displayUrl.replace(/^www\./, '');
      // Truncate if too long
      if (displayUrl.length > 50) {
        return displayUrl.substring(0, 47) + '...';
      }
      return displayUrl;
    } catch {
      // If URL parsing fails, just truncate the string
      return url.length > 50 ? url.substring(0, 47) + '...' : url;
    }
  };

  const getClickPercentage = (clicks) => {
    if (maxClicks === 0) return 0;
    return (clicks / maxClicks) * 100;
  };

  if (links.length === 0) {
    return (
      <Box bg="white" p={6} borderRadius="lg" shadow="sm">
        <Heading size="md" mb={4}>Links Mais Clicados</Heading>
        <Box textAlign="center" py={8}>
          <Icon as={MdTouchApp} boxSize={12} color="gray.300" mb={3} />
          <Text color="gray.500">
            Nenhum link foi clicado ainda nesta campanha
          </Text>
          <Text fontSize="sm" color="gray.400" mt={2}>
            Os links clicados aparecerão aqui quando os destinatários interagirem com o email
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <Box bg="white" p={6} borderRadius="lg" shadow="sm">
      <Heading size="md" mb={4}>Links Mais Clicados</Heading>
      
      <Box overflowX="auto">
        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th width="5%">#</Th>
              <Th width="50%">URL</Th>
              <Th width="15%" isNumeric>Cliques Totais</Th>
              <Th width="15%" isNumeric>Cliques Únicos</Th>
              <Th width="15%">Performance</Th>
            </Tr>
          </Thead>
          <Tbody>
            {links.map((link, index) => (
              <Tr key={index} _hover={{ bg: 'gray.50' }}>
                <Td>
                  <Badge colorScheme={index < 3 ? 'gold' : 'gray'} variant="subtle">
                    {index + 1}
                  </Badge>
                </Td>
                <Td>
                  <Tooltip label={link.url} placement="top" hasArrow>
                    <Link
                      href={link.url}
                      isExternal
                      color="blue.600"
                      fontSize="sm"
                      _hover={{ textDecoration: 'underline' }}
                    >
                      <HStack spacing={1}>
                        <Text noOfLines={1}>{formatUrl(link.url)}</Text>
                        <ExternalLinkIcon boxSize={3} />
                      </HStack>
                    </Link>
                  </Tooltip>
                </Td>
                <Td isNumeric>
                  <HStack justify="flex-end" spacing={1}>
                    <Icon as={MdTouchApp} boxSize={3} color="orange.500" />
                    <Text fontWeight="bold" color="orange.600">
                      {link.totalClicks}
                    </Text>
                  </HStack>
                </Td>
                <Td isNumeric>
                  <Text>{link.uniqueClickers}</Text>
                </Td>
                <Td>
                  <Box>
                    <Progress
                      value={getClickPercentage(link.totalClicks)}
                      size="sm"
                      colorScheme={index === 0 ? 'orange' : index < 3 ? 'blue' : 'gray'}
                      borderRadius="full"
                    />
                    <Text fontSize="xs" color="gray.600" mt={1}>
                      {getClickPercentage(link.totalClicks).toFixed(0)}% do máximo
                    </Text>
                  </Box>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {links.length > 0 && (
        <Box mt={4} p={3} bg="orange.50" borderRadius="md" borderLeft="4px" borderLeftColor="orange.400">
          <Text fontSize="sm" color="gray.700">
            <strong>Link mais popular:</strong> {formatUrl(links[0].url)} com {links[0].totalClicks} cliques totais
            ({links[0].uniqueClickers} cliques únicos)
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default TopLinks;